import {
    TransferProductType,
    TransferConnection,
    TransferSearchFlow,
} from '@/helpers/transfer/transfer.interfaces';
import {
    addTimeToDate,
    convertToDate,
    getDateAddingDuration,
    getDateSubtractingDuration,
    getFormattedDate,
} from '@shared/helpers/datetime/datetime';
import {
    FERRY_BUFFER_DROP_OFF,
    FERRY_BUFFER_PICKUP,
    FLIGHT_BUFFER_DROP_OFF,
    FLIGHT_BUFFER_PICKUP,
    VEHICLE_DURATION_BUFFER,
} from '@/helpers/transfer/transfer.consts';
import { DateFormat } from '@shared/interfaces/dates';

interface TransferTimes {
    startTime: string | null;
    flightArrivalTime: string | null;
    flightDepartureTime: string | null;
}

export const getTransferTimes = (
    connection: TransferConnection,
    searchFlow: TransferSearchFlow
): TransferTimes => {
    let startTime = null;
    let flightArrivalTime = null;
    let flightDepartureTime = null;

    if (searchFlow === TransferSearchFlow.Custom) {
        startTime = getCalculatedStartTime(connection);
    }

    if (searchFlow === TransferSearchFlow.Flight) {
        const isArrival = connection.from.productType === TransferProductType.Flight;
        const flightTime = getFlightTime(connection);
        flightArrivalTime = isArrival ? flightTime : null;
        flightDepartureTime = !isArrival ? flightTime : null;
    }

    return {
        startTime,
        flightArrivalTime,
        flightDepartureTime,
    };
};

function getCalculatedStartTime(connection: TransferConnection): string | null {
    let date: Date | null = null;
    const { from, to } = connection;

    // FLIGHT
    if (to.productType === TransferProductType.Flight) {
        date = getDateSubtractingDuration(to.date, {
            minutes: VEHICLE_DURATION_BUFFER + FLIGHT_BUFFER_DROP_OFF,
        });
    } else if (from.productType === TransferProductType.Flight) {
        date = getDateAddingDuration(from.date, {
            minutes: FLIGHT_BUFFER_PICKUP,
        });
    }

    // FERRY
    else if (to.productType === TransferProductType.Ferry) {
        date = getDateSubtractingDuration(to.date, {
            minutes: VEHICLE_DURATION_BUFFER + FERRY_BUFFER_DROP_OFF,
        });
    } else if (from.productType === TransferProductType.Ferry) {
        date = getDateAddingDuration(from.date, {
            minutes: FERRY_BUFFER_PICKUP,
        });
    }

    if (date) {
        return getFormattedDate(date, DateFormat.ISO);
    } else {
        return addTimeToDate(convertToDate(from.date), '12:00');
    }
}

function getFlightTime(connection: TransferConnection): string | null {
    let date: Date | undefined;

    if (connection.to.productType === TransferProductType.Flight) {
        date = connection.to.date;
    } else if (connection.from.productType === TransferProductType.Flight) {
        date = connection.from.date;
    }

    return date ? getFormattedDate(date, DateFormat.ISO) : null;
}
